var React = require('react');

function DropdownCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Icon_ionic-md-arrow-dropdown-circle-2","data-name":"Icon ionic-md-arrow-dropdown-circle","d":"M18.375,3.375a15,15,0,1,0,15,15A15,15,0,0,0,18.375,3.375Zm0,19.615-6.923-6.923H25.3Z","transform":"translate(-3.375 -3.375)"}));
}

DropdownCircle.defaultProps = {"id":"Icon_ionic-md-arrow-dropdown-circle","data-name":"Icon ionic-md-arrow-dropdown-circle","width":"30","height":"30","viewBox":"0 0 30 30"};

module.exports = DropdownCircle;

DropdownCircle.default = DropdownCircle;
